// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sLHpU","content":"styles_content__1DWp1","tableWrap":"styles_tableWrap__vWwg0"};